import { apiGET, apiPUT, apiPOST } from './api';

export const getSettings = () => apiGET('/settings');

export const updateSettings = settings => apiPUT('/settings', settings);

// Rebuild the api's in-process cache of Mailtrap-hosted notification templates,
// applying PM/QA edits made in the Mailtrap UI without a redeploy.
export const reloadTemplates = () => apiPOST('/settings/reload_templates', {});
